import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { PrivacyHeadline, PrivacySubSubHeadline, PrivacyTextWrapper, PrivacySubHeadline } from '../StyledComponents/Pages/Privacy'


class Impressum extends Component {
    render() {
        return (
            <PrivacyTextWrapper>
                <PrivacyHeadline>Impressum</PrivacyHeadline>
                <PrivacySubHeadline>Angaben gemäß § 5 TMG:</PrivacySubHeadline>
                <p>Team FlowerAI<br /></p>
                <PrivacySubSubHeadline>Postanschrift:</PrivacySubSubHeadline>
                <p>Herrenberger Straße 105/1<br />71069 Sindelfingen<br /></p>
                <h3>Kontakt:</h3>
                <p>Telefon: 0173 7503892<br />E-Mail: sebastian.muhle@flowerai.de</p>
                <PrivacySubSubHeadline>Vertreten durch:</PrivacySubSubHeadline>
                <p>Sebastian Muhle (CEO)
                    <br />Philip Lenhart (CTO)
                </p>
                <PrivacySubHeadline>Berufsrechtliche Angaben </PrivacySubHeadline>
                <PrivacySubHeadline>Hinweise zur Website</PrivacySubHeadline>
                <PrivacySubSubHeadline>Urheberrechtliche Hinweise</PrivacySubSubHeadline>
                <p>An einigen Stellen verwenden wir <Link to="https://icons8.com/">Icons8</Link> um Icons darzustellen. Diese dürfen wir gemäß der <Link to="https://creativecommons.org/licenses/by-nd/3.0/">Creative Commons Attribution-NoDerivs 3.0 Unported</Link> Lizenz verwenden.<br /></p>
                <PrivacySubHeadline>Information gemäß § 36 VSBG</PrivacySubHeadline>
                <p>
                    {'Gemäß § 36 VSBG (Verbraucherstreitbeilegungsgesetz – Gesetz über die alternative Streitbeilegung in Verbrauchersachen) erklärt der Betreiber dieser Website:'}
                </p>
                <p>
                    {'Wir sind weder bereit noch verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.'}
                </p>
                <p>
                    <em>
                        {'Das Impressum wurde mit dem '}
                        <a href="https://www.activemind.de/datenschutz/impressums-generator/">
                            {'Impressums-Generator der activeMind AG'}
                        </a>
                        {' erstellt.'}
                    </em>
                </p>

                <PrivacySubHeadline>Haftung für Inhalte</PrivacySubHeadline>
                <p>
                    {'Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.'}
                </p>
                <p>
                    {'Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.'}
                </p>

                <PrivacySubHeadline>Haftung für Links</PrivacySubHeadline>
                <p>
                    {'Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.'}
                </p>
                <p>
                    {'Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.'}
                </p>

                <PrivacySubHeadline>Urheberrecht</PrivacySubHeadline>
                <p>
                    {'Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.'}
                </p>
                <p>
                    {'Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.'}
                </p>
            </PrivacyTextWrapper>
        )
    }
}

export default withRouter(Impressum)



// WEBPACK FOOTER //
// ./src/components/pages/Impressum.js